import { render, staticRenderFns } from "./PeriodDropdownFilter.vue?vue&type=template&id=56753610&scoped=true&"
import script from "./PeriodDropdownFilter.vue?vue&type=script&lang=js&"
export * from "./PeriodDropdownFilter.vue?vue&type=script&lang=js&"
import style0 from "./PeriodDropdownFilter.vue?vue&type=style&index=0&id=56753610&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56753610",
  null
  
)

export default component.exports